import React, { useContext, useEffect, useMemo, useState } from "react";
import Slider from "../Components/Slider/Slider";
import { Link } from "react-router-dom";
import { AiOutlineCalendar } from "react-icons/ai";
import { FaPhoneVolume } from "react-icons/fa";
import { NoImage } from "../Images";
import ReactHtmlParser from "react-html-parser";
import CommonContext from "../Context/context";
import { helperText } from "../Helper/helperFunctions";
import { getBannerData, getGalleryData } from "../Service/ApiFunction";

const Home = () => {
  const [allGalleryData, setAllGalleryDAta] = useState([]);
  const [AllBannerData, setAllBannerData] = useState([]);
  const [aboutTextForHome, setBoutTextForHome] = useState("");
  const { GlobalData, cmsData, ContactNumber, FromPrincipalDesktop } =
    useContext(CommonContext);
  const cmsDataFor = useMemo(
    () => cmsData?.find((ele) => ele?.page == "Home"),
    [cmsData]
  );

  const gallery = async () => {
    const resGallery = await getGalleryData();
    setAllGalleryDAta(resGallery?.data);
  };

  const frontImage = GlobalData?.find(
    (ele) => ele?.title == "about_Us_Front_Image"
  );
  const rareImage = GlobalData?.find(
    (ele) => ele?.title == "about_Us_Rare_Image"
  );
  const Chronological_Development_Image = GlobalData?.find(
    (ele) => ele?.title === "Chronological_Development_Image"
  );

  const getBannerDataVal = async () => {
    const responseBanner = await getBannerData();

    setAllBannerData(responseBanner?.data);
  };

  useEffect(() => {
    gallery();
    getBannerDataVal();
  }, []);

  let ImageDisplayBanner =
    allGalleryData?.length &&
    allGalleryData?.map((ele, index) => (
      <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
        <div className="gallery-main">
          <div className="gallery-img">
            <img src={ele?.file} alt={`banner${index}`} />
          </div>
          <div className="gallery-title">
            <p className="mb-0">{ele?.title}</p>
          </div>
        </div>
      </div>
    ));

  let galleryRenderImages = useMemo(() => {
    if (!ImageDisplayBanner)
      return (
        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="gallery-main">
            <div className="gallery-img">
              <img src={NoImage} alt="noimage" />
            </div>
          </div>
        </div>
      );
    if (ImageDisplayBanner.length > 6) {
      return ImageDisplayBanner.splice(0, 6);
    }
    return ImageDisplayBanner;
  }, [gallery]);

  useEffect(() => {
    if (cmsData?.length > 0) {
      let descriptionPara = ReactHtmlParser(cmsDataFor?.description);

      setBoutTextForHome(descriptionPara);
    }
  }, [cmsData]);

  return (
    <>
      <Slider AllBannerData={AllBannerData} />
      <div className="about-section about-inner-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="image-block">
                <div className="image-one">
                  <img
                    src={frontImage?.file ? frontImage?.file : NoImage}
                    alt="front"
                  />
                </div>
                <div className="image-two">
                  <img
                    src={rareImage?.file ? rareImage?.file : NoImage}
                    alt="rare"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="content-block">
                <div className="sec-title mb-4">
                  <div className="text sub-title">About Us</div>
                  {cmsDataFor?.description ? (
                    <span>{aboutTextForHome}</span>
                  ) : (
                    helperText
                  )}
                </div>
                <div className="bottom-content">
                  <h4 style={{ marginTop: "0px" }}>Call Us</h4>
                  <div className="contact-number">
                    <Link to="/">
                      <div className="call">
                        <FaPhoneVolume />
                      </div>
                      {ContactNumber?.file || "0000000000"}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="quote-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 align-self-center">
              <div className="Principal-img">
                <img
                  alt=""
                  src={
                    (GlobalData?.length &&
                      GlobalData?.find((ele) => ele?.title == "principle_Image")
                        ?.file) ||
                    NoImage
                  }
                />
              </div>
            </div>
            <div className="col-lg-8 align-self-center">
              <aside className="fancy-quote">
                <h2>From The Desk Of Principal</h2>
                <blockquote>
                  <p>
                    {(FromPrincipalDesktop?.file &&
                      FromPrincipalDesktop?.file?.startsWith("<p>")) ||
                    (FromPrincipalDesktop?.file &&
                      FromPrincipalDesktop?.file?.startsWith("<h1>")) ||
                    (FromPrincipalDesktop?.file &&
                      FromPrincipalDesktop?.file?.startsWith("<h2>"))
                      ? ReactHtmlParser(FromPrincipalDesktop?.file)
                      : FromPrincipalDesktop?.file
                      ? FromPrincipalDesktop?.file
                      : helperText}
                  </p>
                </blockquote>
                <span>
                  &#8212; Principal,{" "}
                  <cite>
                    {(GlobalData?.length &&
                      GlobalData?.find((ele) => ele?.title == "principle_Name")
                        ?.file) ||
                      "Name Of Principal"}
                  </cite>
                </span>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div className="gallery-sec gallery-home-bg">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="sec-title text-center mb-4">
                <div className="sub-title">Gallery</div>
                <h2 className="mb-4">Our Gallery</h2>
              </div>
            </div>
          </div>
          <div className="row mt-5">{galleryRenderImages}</div>
          <div className="row">
            <div className="col-12 text-center mt-5">
              <Link className="theme-btn btn-style-one homeNav" to="/gallery">
                View All Gallery
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="step-bg">
        <div className="step-bg-1"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h2>Chronological Development</h2>
              <div className="d-flex">
                <ul className="steps-list">
                  <li className="steps-item">
                    <h3>Inauguration of the School</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      18 May 1995
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Extension of School Bldgs</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      30 April 2005
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>1 st Educational Excursion</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      25 Dec 2007
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Upgraded to U.Pry School</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      02 May 2008
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Opening up Br.Instn. Ankhona</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      07 Feb 2011
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Upgradation of Madhyamik</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      02 Jan 2012
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Inauguration of New Campus</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      25 Dec 2012
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Provisional Govt. Recognition</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      27 Jun 2013
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>1st M.P Exam Appearance</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      25 Feb 2014
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Opening 2nd Br. at Farakka</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      27 Jan 2018
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>School ERP/ Online Mgmt</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      01 Apr 2019
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Upgradation to H.S School</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      01 July 2019
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Lab for Science & Geography</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      15 Aug 2019
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Banglar Siksha Portal Entry</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      02 Jan 2022
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Website of the Org. Launched</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      01 July 2023
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="chronological-bg">
                <img
                  src={Chronological_Development_Image?.file}
                  alt="chronological"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
